import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", function (event) {
    window.addEventListener("load", function (e) {

        if ($('.ticker').length > 0) {
            gsap.registerEffect({
                name: "ticker",
                effect(targets, config) {
                    let master = gsap.timeline();
                    buildTickers(targets, config);

                    function clone(el) {
                        let clone = el.cloneNode(true);
                        el.parentNode.insertBefore(clone, el);
                        clone.style.position = "absolute";
                        return clone;
                    }

                    function nestChildren(el, className) {
                        let div = document.createElement("div");
                        while (el.firstChild) {
                            div.appendChild(el.firstChild);
                        }
                        el.appendChild(div);
                        className && div.setAttribute("class", className);
                        div.style.display = "flex";
                        div.style.boxSizing = "border-box";
                        // The parent (.ticker-wrapper) is itself a flex container, so this
                        // chunk is a flex item and shrinks to the wrapper width by default.
                        // That makes its measured width narrower than its real (overflowing)
                        // content, so clones get positioned too close and the 2nd set overlaps
                        // the end of the 1st. Force it to its intrinsic content width.
                        div.style.flex = "0 0 auto";
                        div.style.width = "max-content";
                        return div;
                    }

                    function buildTickers(targets, config, isResize) {
                        if (isResize) { // on window resizes, we should delete the old clones and reset the widths
                            targets.clones.forEach(el => el && el.parentNode && el.parentNode.removeChild(el));
                            gsap.set(targets.chunks, { x: 0 });
                        } else {
                            targets.clones = [];
                            targets.chunks = [];
                        }
                        master.clear();

                        let clones = targets.clones,
                        chunks = targets.chunks;

                        targets.forEach((el, index) => {
                            let chunk = chunks[index] || (chunks[index] = nestChildren(el, config.className)),
                            // Use the fractional layout width (getBoundingClientRect) rather than
                            // the integer-rounded offsetWidth. offsetWidth rounds the true width,
                            // and when clones are positioned at that rounded value the sub-pixel
                            // difference makes the start of the 2nd set overlap the end of the 1st.
                            chunkWidth = chunk.getBoundingClientRect().width + (config.padding || 0),
                            cloneCount = Math.ceil(el.offsetWidth / chunkWidth),
                            chunkBounds = chunk.getBoundingClientRect(),
                            elBounds = el.getBoundingClientRect(),
                            right = (el.dataset.direction || config.direction) === "right",
                            tl = gsap.timeline(),
                            speed = parseFloat(el.dataset.speed) || config.speed || 100,
                            i, offsetX, offsetY, bounds, cloneChunk, all;

                            el.style.overflow = "hidden";
                            gsap.getProperty(el, "position") !== "absolute" && (el.style.position = "relative"); // avoid scrollbars
                            for (i = 0; i < cloneCount; i++) {
                                cloneChunk = clones[i] = clone(chunk);
                                if (!i) {
                                    bounds = cloneChunk.getBoundingClientRect();
                                    offsetX = bounds.left - chunkBounds.left;
                                    offsetY = bounds.top - chunkBounds.top;
                                }
                                gsap.set(cloneChunk, { x: offsetX + (right ? -chunkWidth : chunkWidth) * (i + 1), y: offsetY });
                            }

                            all = clones.slice(0);
                            all.unshift(chunk);

                            if (config.startEmpty !== false) {
                                tl.fromTo(all, {
                                    x: right ? "-=" + (chunkBounds.right - elBounds.left) : "+=" + (elBounds.right - chunkBounds.left)
                                }, {
                                    x: (right ? "+=" : "-=") + elBounds.width,
                                    ease: "none",
                                    duration: elBounds.width / speed,
                                    overwrite: "auto"
                                });
                            }
                            tl.to(all, {
                                x: (right ? "+=" : "-=") + chunkWidth,
                                ease: "none",
                                duration: chunkWidth / speed,
                                repeat: -1
                            });
                            master.add(tl, 0);
                        });
                        // rerun on window resizes, otherwise there could be gaps if the user makes the window bigger.
                        isResize || window.addEventListener("resize", () => buildTickers(targets, config, true));
                    }
                    return master;
                }
            });

            let tl = gsap.effects.ticker(".ticker-wrapper", {
              speed: 100,
              className: "ticker-content",
              //direction: "right",
              //startEmpty: false
            });


            let container = document.querySelector(".ticker");
            container.addEventListener('mouseenter', () => gsap.to(tl, { timeScale: 0, overwrite: true }));
            container.addEventListener('mouseleave', () => gsap.to(tl, { timeScale: 1, overwrite: true }));

        }
    })
})
